import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { APIProvider as GoogleMapsAPIProvider } from '@vis.gl/react-google-maps';

import {
  SnackbarProvider,
  LoadingProvider,
  ConfirmationProvider,
  DrawerProvider,
  DeveloperProvider,
} from '@carcareers/contexts';
import { GoogleAnalytics } from '@carcareers/components';
import { router, sentry } from '@carcareers/utils';
import { store } from '@carcareers/store';
import { theme } from '@carcareers/theme';

import './assets/css/index.css';

// Trigger Build

sentry();

// trigger build

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <HelmetProvider>
      <GoogleAnalytics />
      <ReduxProvider store={store}>
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <GoogleMapsAPIProvider
              apiKey={process.env.NX_GOOGLE_MAPS_API_KEY || ''}
              libraries={['places', 'visualization']}
              version="3.64"
            >
              <CssBaseline />
              <DeveloperProvider>
                <DrawerProvider>
                  <SnackbarProvider>
                    <LoadingProvider>
                      <ConfirmationProvider>
                        <RouterProvider router={router} />
                      </ConfirmationProvider>
                    </LoadingProvider>
                  </SnackbarProvider>
                </DrawerProvider>
              </DeveloperProvider>
            </GoogleMapsAPIProvider>
          </LocalizationProvider>
        </ThemeProvider>
      </ReduxProvider>
    </HelmetProvider>
  </StrictMode>,
);

// trigger build
